import React from "react";

export function ActionFooter({ children, className = "" }) {
	return (
		<div
			className={`py-3 flex items-center justify-center z-50 sticky bottom-0 w-full bg-white ${className}`}
		>
			<div className="flex items-center justify-center">{children}</div>
		</div>
	);
}
